import { ecosystemHeadProfileHref } from "@/pages/ecosystem-heads/ecosystemHeads.const";
import { invalidateMyEcosystemHeadLinks } from "@/state/hooks/useMyEcosystemHeadLinksQuery";

export const MY_CLUSTER_PATH = "/my-cluster";

export const MY_CLUSTER_COUNT_REFRESH_EVENT = "gt:my-cluster-count-refresh";

export function notifyMyClusterCountChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(MY_CLUSTER_COUNT_REFRESH_EVENT));
  void invalidateMyEcosystemHeadLinks();
}

export type SignupClusterHome = {
  headUserId: string;
  industry: string;
  corridorSignupFreeCollaborationEnabled?: boolean;
};

type ClusterSignupUserFields = {
  signupSource?: string | null;
  signupCluster?: SignupClusterHome | null;
};

export function isClusterSignupHomePath(pathname: string, homePath: string): boolean {
  return pathname === homePath || pathname.startsWith(`${homePath}/`);
}

/** Origin cluster profile for CLUSTER-signup users; `/my-cluster` if the slug cannot be resolved. */
export function getClusterSignupHomePath(user: ClusterSignupUserFields | null | undefined): string | null {
  if (user?.signupSource !== "CLUSTER") return null;
  const industry = user.signupCluster?.industry?.trim();
  const headUserId = user.signupCluster?.headUserId?.trim();
  if (industry && headUserId) {
    return ecosystemHeadProfileHref(industry, headUserId);
  }
  return MY_CLUSTER_PATH;
}
